import { useEffect } from 'react';
import { useSubscription } from '@apollo/client';
import { MESSAGE_RECEIVED } from '../graphql/subscriptions';
import { useChatStore } from '../stores/chatStore';
import type { Message } from '../types/chat.types';

/**
 * Hook for subscribing to new messages
 */
export function useMessageSubscription() {
  const { addMessage, setTyping } = useChatStore();

  const { data, error } = useSubscription<{ messageReceived: Message }>(MESSAGE_RECEIVED, {
    onData: ({ data }) => {
      if (data?.data?.messageReceived) {
        const message = data.data.messageReceived;

        // Skip user messages from subscription — they are handled optimistically via mutation
        if (message.sender === 'user') return;

        // Add message to store
        addMessage(message);

        // Stop typing indicator when message is received
        setTyping(false);
      }
    },
    onError: (error) => {
      console.error('Subscription error:', error);
    },
  });

  // Handle typing indicator
  useEffect(() => {
    if (data?.messageReceived?.sender === 'bot') {
      // You could implement typing indicator logic here if needed
      // For now, we just ensure typing is off when message arrives
      setTyping(false);
    }
  }, [data, setTyping]);

  return {
    error,
  };
}
